<template>
  <div>
    <el-row type="flex" justify="space-between" align="bottom" :gutter="20" class="header1">
      <el-col class="bold">{{ date+'-'+word }}</el-col>
      <el-col style="text-align: right;">
        <el-button type="primary" @click="onDownload">导出报表</el-button>
        <el-button type="primary" @click="onPrint">打印报表</el-button>
      </el-col>
    </el-row>
    <br />
    <el-table tooltip-effect="light" :data="tableData" style="width: 100%">
      <el-table-column v-if="word==='退款详情'" label="退款时间">
        <template slot-scope="scope">
          <span>{{ scope.row.dateTime || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="word==='支付详情'" prop="dateTime" label="支付时间"></el-table-column>
      <el-table-column v-if="word!=='支付详情'" label="开单时间">
        <template slot-scope="scope">
          <span>{{ scope.row.orderTime || scope.row.dateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderCode" label="订单号"></el-table-column>
      <el-table-column v-if="word==='退款详情'" prop="amount" label="退款金额（元）"></el-table-column>
      <el-table-column v-if="word==='退款详情'" prop="payType" label="退款渠道"></el-table-column>
      <el-table-column v-if="word==='退款详情'" prop="initiatorName" label="退款发起人">
        <template slot-scope="scope">
          <span>{{ scope.row.initiatorName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="word==='退款详情'" prop="dutyName" label="退款授权人">
        <template slot-scope="scope">
          <span>{{ scope.row.dutyName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="word==='退款详情'" prop="refundStatus" label="退款状态">
        <template slot-scope="scope">
          <span>{{ scope.row.refundStatus || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="word!=='退款详情' && word !== '支付详情'" prop="type" label="类型"></el-table-column>
      <el-table-column v-if="word==='支付详情'" prop="orderType" label="类型"></el-table-column>
      <el-table-column v-if="word==='支付详情'" prop="payType" label="支付方式"></el-table-column>
      <el-table-column v-if="word==='支付详情'" prop="amount" label="支付金额(元)"></el-table-column>
      <el-table-column v-if="word==='收入详情'" prop="realMoney" label="收入金额(元)"></el-table-column>
      <el-table-column v-if="word==='收入详情'" prop="payTypeName" label="支付方式"></el-table-column>
      <el-table-column v-if="word==='优惠详情'" prop="discountMoney" label="优惠金额(元)"></el-table-column>
      <el-table-column v-if="word==='划扣金额详情'" prop="deductMoney" label="划扣金额(元)"></el-table-column>
      <el-table-column v-if="word==='应收欠款详情'" prop="money" label="应收欠款金额(元)"></el-table-column>
    </el-table>

    <el-pagination v-if="tableData.length>0" background layout="prev, pager, next" :total="total" :current-page.sync="pageNum" @current-change="currentChange"></el-pagination>
  </div>
</template>

<script>
import api from '../../api/index';

export default {
  components: {},
  data() {
    return {
      word: '',
      date: '',
      tableData: [],
      pageNum: 1,
      total: 0
    };
  },
  computed: {},
  watch: {},
  activated() {
    this.word = this.$route.params.word
      ? this.$route.params.word
      : localStorage.getItem('word');
    this.date = this.$route.params.date
      ? this.$route.params.date
      : localStorage.getItem('date');
    this.value = this.$route.params.timeCountType
      ? this.$route.params.timeCountType
      : localStorage.getItem('timeCountType');
    this.$route.params.word
      ? localStorage.setItem('word', this.$route.params.word)
      : '';
    this.$route.params.date
      ? localStorage.setItem('date', this.$route.params.date)
      : '';
    this.$route.params.timeCountType
      ? localStorage.setItem('timeCountType', this.$route.params.timeCountType)
      : '';
    this.pageNum = 1;
    if (this.word === '收入详情') {
      this.getIncomeData();
    }
    if (this.word === '优惠详情') {
      this.getDiscountData();
    }
    if (this.word === '划扣金额详情') {
      this.getDeductData();
    }
    if (this.word === '应收欠款详情') {
      this.getDebtData();
    }
    if (this.word === '支付详情') {
      this.getPayData();
    }
    if (this.word === '退款详情') {
      this.getRefundData();
    }
  },
  methods: {
    // 获取 收入明细列表详情
    getIncomeData() {
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      api.getIncomeData(data).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 获取 优惠明细列表详情
    getDiscountData() {
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      api.getDiscountData(data).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 获取 划扣金额明细详情
    getDeductData() {
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      api.getDeductData(data).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 获取 应收欠款明细列表详情
    getDebtData() {
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      api.getDebtData(data).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 获取 支付详情列表数据
    getPayData() {
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      api.getIncomeDetails(data).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 获取 退款明细详情列表数据
    getRefundData() {
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.pageNum,
        pageSize: 10,
        timeCountType: this.value
      };
      api.getRefundAnalyse(data).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    currentChange() {
      if (this.word === '收入详情') {
        this.getIncomeData();
      }
      if (this.word === '优惠详情') {
        this.getDiscountData();
      }
      if (this.word === '划扣金额详情') {
        this.getDeductData();
      }
      if (this.word === '应收欠款详情') {
        this.getDebtData();
      }
      if (this.word === '支付详情') {
        this.getPayData();
      }
      if (this.word === '退款详情') {
        this.getRefundData();
      }
    },
    onDownload() {
      if (this.Lib.checkPower('beauty-5-dcyygkxq') == false) return;
      if (this.word === '收入详情') {
        this.$root.$children[0].fatherExport('exportIncomeData', this.date, this.value);
      }
      if (this.word === '优惠详情') {
        this.$root.$children[0].fatherExport('exportDiscoutData', this.date, this.value);
      }
      if (this.word === '划扣金额详情') {
        this.$root.$children[0].fatherExport('exportDeductData', this.date, this.value);
      }
      if (this.word === '应收欠款详情') {
        this.$root.$children[0].fatherExport('exportDebtData', this.date, this.value);
      }
      if (this.word === '支付详情') {
        this.$root.$children[0].fatherExport('exportIncomeDetails', this.date, this.value);
      }
      if (this.word === '退款详情') {
        this.$root.$children[0].fatherExport('exportRefundAnalyse', this.date, this.value);
      }
    },
    onPrint() {
      if (this.Lib.checkPower('beauty-5-dyyygkxq') == false) return;
      const data = {
        dateTime: this.date,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: 1,
        pageSize: 999999,
        timeCountType: this.value
      };
      if (this.word === '收入详情') {
        api.getIncomeData(data).then((res) => {
          this.$print({
            data: res.data.records,
            table_tol: [
              {
                name: '开单时间',
                prop: 'dateTime'
              },
              {
                name: '订单号',
                prop: 'orderCode'
              },
              {
                name: '类型',
                prop: 'type'
              },
              {
                name: '收入金额(元)',
                prop: 'realMoney'
              },
              {
                name: '支付方式',
                prop: 'payTypeName'
              }
            ],
            title: `${this.date}—收入详情`
          });
        });
      }
      if (this.word === '优惠详情') {
        api.getDiscountData(data).then((res) => {
          this.$print({
            data: res.data.records,
            table_tol: [
              {
                name: '开单时间',
                prop: 'dateTime'
              },
              {
                name: '订单号',
                prop: 'orderCode'
              },
              {
                name: '类型',
                prop: 'type'
              },
              {
                name: '优惠金额(元)',
                prop: 'discountMoney'
              }
            ],
            title: `${this.date}—优惠详情`
          });
        });
      }
      if (this.word === '划扣金额详情') {
        // console.log(data)
        api.getDeductData(data).then((res) => {
          this.$print({
            data: res.data.records,
            table_tol: [
              {
                name: '开单时间',
                prop: 'dateTime'
              },
              {
                name: '订单号',
                prop: 'orderCode'
              },
              {
                name: '类型',
                prop: 'type'
              },
              {
                name: '划扣金额(元)',
                prop: 'deductMoney'
              }
            ],
            title: `${this.date}—划扣金额详情`
          });
        });
      }
      if (this.word === '应收欠款详情') {
        api.getDebtData(data).then((res) => {
          this.$print({
            data: res.data.records,
            table_tol: [
              {
                name: '开单时间',
                prop: 'dateTime'
              },
              {
                name: '订单号',
                prop: 'orderCode'
              },
              {
                name: '类型',
                prop: 'type'
              },
              {
                name: '应收欠款金额(元)',
                prop: 'money'
              }
            ],
            title: `${this.date}—应收欠款详情`
          });
        });
      }
      if (this.word === '支付详情') {
        api.getIncomeDetails(data).then((res) => {
          this.$print({
            data: res.data.records,
            table_tol: [
              {
                name: '支付时间',
                prop: 'dateTime'
              },
              {
                name: '订单号',
                prop: 'orderCode'
              },
              {
                name: '类型',
                prop: 'orderType'
              },
              {
                name: '支付方式',
                prop: 'payType'
              },
              {
                name: '支付金额(元)',
                prop: 'amount'
              }
            ],
            title: `${this.date}—支付详情`
          });
        });
      }
      if (this.word === '退款详情') {
        api.getRefundAnalyse(data).then((res) => {
          this.$print({
            data: res.data.records,
            table_tol: [
              {
                name: '退款状态',
                prop: 'refundStatus'
              },
              {
                name: '退款授权人',
                prop: 'dutyName'
              },
              {
                name: '订单号',
                prop: 'orderCode'
              },
              {
                name: '退款金额（元）',
                prop: 'amount'
              },
              {
                name: '退款渠道',
                prop: 'payType'
              },
              {
                name: '退款发起人',
                prop: 'initiatorName'
              },
              {
                name: '开单时间',
                prop: 'orderTime'
              },
              {
                name: '退款时间',
                prop: 'dateTime'
              }
            ],
            title: `${this.date}—退款详情`
          });
        });
      }
    }
  }
};
</script>
<style scoped>
.header1 {
    border-bottom: 1px solid #dfe4ed;
    padding-bottom: 10px;
}
.bold {
    font-weight: bold;
}
</style>
